import { MotionLoaderFullscreen } from "@/components/custom/motion-loader.tsx";
import { OnboardingShell } from "@/components/onboarding/onboarding-shell.tsx";
import { m } from "@/paraglide/messages.js";
import { organizationQueryOptions } from "@/services/organization-service.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/onboarding")({
	beforeLoad: ({ context }) => {
		if (!context.auth.isAuthenticated) {
			throw redirect({
				to: "/auth/login",
			});
		}

		// FROZEN FIRST. This route has its own guard — it is the DESTINATION of the
		// shared one, so it cannot use it — and without this arm a member of a frozen
		// org sits here permanently: every call the wizard makes goes through
		// `authenticate`, which refuses a frozen org, so each step fails with "this
		// organization has been suspended" and there is no way forward or back.
		//
		// It is how a contract customer met the product: they set their password,
		// were sent here, and every button failed.
		if (context.auth.user?.isOrgFrozen) {
			throw redirect({
				to: "/suspended",
			});
		}

		if (context.auth.user?.onboardingCompleted) {
			throw redirect({
				to: "/home",
			});
		}
	},
	// The sidebar's organization row reads this; prefetched so the shell
	// renders in one pass like the dashboard does.
	loader: ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(organizationQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.onboarding_title()) }],
	}),
	pendingComponent: () => <MotionLoaderFullscreen text={m.common_loading()} />,
	component: OnboardingShell,
});
